/* eslint-disable babel/camelcase */
import React, { useState, useRef } from "react";
import { postToRails } from "venuescanner-js/services/api";
import PropTypes from "prop-types";
import cl from "classnames";
import classes from "./styles.module.scss";
import Form from "venuescanner-js/react/components/Form/Form";
import Password from "venuescanner-js/react/components/Form/Fields/Password/FormInput";
import Input from "venuescanner-js/react/components/Form/Fields/Input/FormInput";
import Phone from "venuescanner-js/react/components/Form/Fields/Phone/FormInput";
import Row from "venuescanner-js/react/components/Form/Row";
import CenteredRow from "venuescanner-js/react/components/Form/CenteredRow";
import { detailsValidation } from "venuescanner-js/validation/profile";
import Submit from "venuescanner-js/react/components/Form/button/Submit";
import Loading from "venuescanner-js/react/components/Loading";
import Confirmation from "venuescanner-js/react/components/Form/Notifications/Confirmation";
import Radio from "venuescanner-js/react/components/Form/Fields/Radio/FormRadio";
import Toggle from "venuescanner-js/react/components/Form/Fields/Toggle/FormInput";
import Message from "venuescanner-js/react/components/Form/Notifications/Message";
import TemporaryWarning, {
  TemporaryWarningTrigger,
} from "venuescanner-js/react/components/Form/Notifications/TemporaryWarning";

const Logo = () => (
  <a href="/" className={classes.auth__logo}>
    &nbsp;
  </a>
);

const Details = ({ saved, user }) => {
  const initialValues = {
    name: user.name,
    lastName: user.lastName,
    phone: user.phone,
    marketing: "",
    agree: "",
    newpassword: "",
    confirmpassword: "",
  };
  const formContainer = useRef(null);
  const [updating, setUpdating] = useState(false);
  const [loggedIn] = useState(false);
  const [failedMessage] = useState(null);
  const [invalidEmitter] = useState(new TemporaryWarningTrigger());
  const handleRegisterChange = (...args) => {};
  const handleRegisterSubmit = async (values, { resetForm }) => {
    const { phone, newpassword, confirmpassword, name, lastName, marketing } =
      values;

    // console.log(values)
    setUpdating(true);

    const data = await postToRails("users/me", {
      phone,
      password: newpassword,
      name,
      lastName,
      communications: {
        marketing: marketing === "on",
      },
    });
    window.data.user = data.user;
    if (saved) saved(data);
    if (window.main && window.main.appendNavData) window.main.appendNavData();
  };
  return (
    <>
      <Logo />
      <div ref={formContainer} className={classes.register}>
        <h3>Hi {user.name}</h3>
        <p>
          Before going any further,
          <br />
          you need to confirm some details and set your password&hellip;
          <br />
        </p>
        <Form
          initialValues={initialValues}
          validation={detailsValidation}
          handleSubmit={handleRegisterSubmit}
          handleChange={handleRegisterChange}
          // handleValidationError={console.log}
        >
          <div
            className={cl(
              { [classes.completed]: loggedIn },
              classes.register__form
            )}
          >
            <Row>
              <Input label="First name" name="name" />
              <Input label="Last name" name="lastName" />
            </Row>
            <Row>
              <Phone label="Phone †" name="phone" />
            </Row>
            <Row>
              <Password label="Password" name="newpassword" />
              <Password label="Confirm password" name="confirmpassword" />
            </Row>
          </div>

          <CenteredRow>
            <Row>
              <div>
                I’d love to hear about top tips, offers &amp; rewards (see{" "}
                <a href="/terms-and-conditions" target="_blank">
                  privacy policy
                </a>
              </div>
              <Radio
                name="marketing"
                options={[
                  { value: "on", label: "Yes please" },
                  { value: "off", label: "No thanks", cross: true },
                ]}
              />
              <Message name="marketing" value="off">
                You will not receive marketing emails. Only emails that are
                regarding your enquiry activity.
              </Message>
            </Row>
            <Row>
              <div>
                I agree to the{" "}
                <a href="/terms-and-conditions" target="_blank">
                  Terms &amp; Conditions
                </a>
              </div>
              <Toggle name="agree" />
            </Row>
          </CenteredRow>
          <div className={classes["cta-area"]}>
            <TemporaryWarning
              message={failedMessage}
              eventEmitter={invalidEmitter}
              closeButton={true}
              duration={20000}
            />
            {updating ? (
              <Loading>Updating...</Loading>
            ) : (
              <Submit visible={!loggedIn}>Save</Submit>
            )}
          </div>
          <div
            className={cl(
              { [classes.completed]: loggedIn },
              classes.login__confirmation
            )}
          >
            <Confirmation>Tou're details are updated</Confirmation>
          </div>
        </Form>
      </div>
    </>
  );
};

Details.propTypes = {
  saved: PropTypes.func,
  user: PropTypes.object,
};

export default Details;
